import {
  type ICircleObject,
  type IPolygonObject,
  type TGeoObject,
} from '@/microfrontends/filters/shared/types/LEGACY/geoSuggest';

export const isIPolygonObject = (value: TGeoObject): value is IPolygonObject => 'polygon' in value;

export const isICircleObject = (value: TGeoObject): value is ICircleObject => 'center' in value;
